import { useChoiceState } from '@context/ChoiceContext'
import { formatInTimeZone } from 'date-fns-tz'

export const useAppointmentStart = (start?: string) => {
  const { selectedBookableDateAndTime } = useChoiceState()

  const queryParamStart = start ? formatTimeWithOffset(start) : undefined

  // If there is user selected slot we take it instead of what was received as query param
  return selectedBookableDateAndTime.originalStartTimestamp || queryParamStart
}

const formatTimeWithOffset = (time?: string) =>
  formatInTimeZone(new Date(time || ''), 'Europe/Berlin', "yyyy-MM-dd'T'HH:mm:ssXXX")
